import { instance } from './config'
import store from '@/store'

const api = {
  getAiSwitch(businessPartCode) {
    return instance({
      url: `/message/getAiSwitch`,
      method: 'get',
      params: {
        businessPartCode
      }
    })
  },
  /**
   * 获取会话基础信息
   * @param {object} data
   * @param data.userid 真实用户Id(游客不用传)
   * @param data.merchantId
   * @param data.appKey
   * @param data.sc 渠道编号: 1000-PC,1001-微信服务号,1002-微信H5,1003-APP,1004-客服工作台
   * @param data.portalType 1-普通接入(默认)，2-订单详情接入
   * @param data.orderNo portalType为2时必传
   * @param data.userIp
   * @param data.latitude
   * @param data.longitude
   */
  getChatBaseData() {
    const chatStore = store.state.chat
    return instance({
      url: 'indexInit',
      method: 'POST',
      data: {
        appKey: chatStore.chatInfo.appKey,
        sc: chatStore.chatInfo.sc,
        portalType: chatStore.chatInfo.portalType,
        latitude: chatStore.chatInfo.latitude,
        longitude: chatStore.chatInfo.longitude,
        userIp: chatStore.chatInfo.userIp,
        orderNo: chatStore.chatInfo.orderNo,
        merchantCode: chatStore.chatInfo.merchantCode,
        organSign: chatStore.chatInfo.organSign,
        companyId: chatStore.chatInfo.companyId,
        storeId: chatStore.chatInfo.storeId,
        pageId: chatStore.chatInfo.pageId,
        uid: chatStore.nonChatlist ? chatStore.chatInfo.accountId : chatStore.chatInfo.userId,
        userid: chatStore.nonChatlist ? chatStore.chatInfo.accountId : chatStore.chatInfo.userId
      },
      isFormdata: true
    })
  },
  /**
   * 获取会话信息
   * @param {object} data
   * @param data.uid
   * @param data.appKeyForRequest
   * @param data.sc 渠道编号: 1000-PC,1001-微信服务号,1002-微信H5,1003-APP,1004-客服工作台
   * @param data.portalType 1-普通接入(默认)，2-订单详情接入
   * @param data.orderNo portalType为2时必传
   * @param data.userIp
   * @param data.latitude
   * @param data.longitude
   * @param {boolean} noFirst 是否初次获取会话，初次进入会话会发送欢迎语
   */
  getDialogInfo(noFirst = false) {
    const chatStore = store.state.chat
    return instance({
      url: 'getDialog',
      method: 'POST',
      params: {
        noFirst
      },
      data: {
        appKeyForRequest: chatStore.chatInfo.appKey,
        uid: chatStore.chatInfo.userId,
        sc: chatStore.chatInfo.sc,
        portalType: chatStore.chatInfo.portalType,
        latitude: chatStore.chatInfo.latitude,
        longitude: chatStore.chatInfo.longitude,
        userIp: chatStore.chatInfo.userIp,
        orderNo: chatStore.chatInfo.orderNo,
        merchantCode: chatStore.chatInfo.merchantCode,
        companyId: chatStore.chatInfo.companyId,
        storeId: chatStore.chatInfo.storeId,
        refreshFlag: chatStore.refreshFlag
      },
      isFormdata: true
    })
  },
  /**
   * 查询客服工作时间
   */
  getKefuWorkdTime() {
    return instance({
      url: `getKefuWorkdTime`,
      params: {
        appKey: store.state.chat.chatInfo.appKey
      }
    })
  },
  /**
   * 检查黑名单
   */
  checkInBlack(uid) {
    return instance({
      url: 'checkInBlack',
      method: 'POST',
      params: { uid }
    })
  },
  /**
   * 读取当前会话消息
   */
  getCurrentMsg() {
    const chatStore = store.state.chat
    return instance({
      url: `message/history/${chatStore.chatInfo.sessionId}`,
      method: 'POST',
      params: { pageId: chatStore.chatInfo.pageId }
    })
  },
  /**
   * 读取客服信息
   */
  getAgentInfo(uid) {
    return instance({
      url: `message/avatar/${uid}`,
      method: 'POST'
    })
  },
  /**
   * 轮询会话消息
   */
  readMsg() {
    const chatStore = store.state.chat
    return instance({
      url: `message/read/${chatStore.chatInfo.sessionId}`,
      method: 'POST',
      params: {
        pageId: chatStore.chatInfo.pageId,
        userId: chatStore.chatInfo.userId,
        appKeyForRequest: chatStore.chatInfo.appKey
      }
    })
  },
  /**
   * 轮询会话消息-用户批量读取消息接口-新
   */
  batchReadMsg() {
    const chatStore = store.state.chat
    return instance({
      url: `message/batchReadNew`,
      method: 'POST',
      params: {
        pageId: chatStore.chatInfo.pageId,
        userId: chatStore.chatInfo.userId,
        appKeyForRequest: chatStore.chatInfo.appKey,
        dialogId: chatStore.chatInfo.sessionId
      }
    })
  },
  /**
   * 读取历史会话消息
   * @param offset
   * @param size
   */
  getHistoryMsg(offset, size) {
    const chatStore = store.state.chat
    return instance({
      url: `message/beforeDialog`,
      method: 'POST',
      data: {
        pageId: chatStore.chatInfo.pageId,
        userid: chatStore.chatInfo.userId,
        appKey: chatStore.chatInfo.appKey,
        merchantCode: chatStore.chatInfo.merchantCode,
        dialogId: chatStore.chatInfo.sessionId,
        offset,
        size
      }
    })
  },
  /**
   * 会话进线
   */
  joinChat() {
    const chatStore = store.state.chat
    return instance({
      url: `joinKefuAndSendTipsMessage`,
      method: 'POST',
      data: {
        dialogId: chatStore.chatInfo.sessionId
      }
    })
  },
  /**
   * 会话进线ca客服
   * @param {boolean} closeOldDid 关闭老会话，点击名片时调用
   */
  joinCaChat(closeOldDid = false) {
    const chatStore = store.state.chat
    return instance({
      url: `joinCaKefu/${chatStore.chatInfo.sessionId}`,
      params: { closeOldDid }
    })
  },
  /**
   * 发送普通消息
   */
  sendMsg(text) {
    const { sessionId, pageId, sc } = store.state.chat.chatInfo
    return instance({
      url: 'message/sendMessage',
      method: 'POST',
      data: {
        dialogId: sessionId,
        text,
        pageId,
        sc
      }
    })
  },
  /**
   * 用户结束会话
   */
  closeDialog() {
    const chatStore = store.state.chat
    return instance({
      url: `message/close/${chatStore.chatInfo.sessionId}`,
      method: 'POST',
      params: { pageId: chatStore.chatInfo.pageId, pageClose: true },
      isFormdata: true
    })
  },
  /**
   * 会话是否已评价
   * @returns {Promise<{data: boolean}>} 是否已评价: true-是，false-否
   */
  isEstimated() {
    const chatStore = store.state.chat
    return instance({
      url: `message/haveAdviced/${chatStore.estimationSessionId}`
    })
  },
  /**
   * 评价
   * @param estimate 1-非常满意，2-满意，3-一般，4-不满意，5-非常不满意
   * @param advice 评价描述
   */
  estimate(estimate = 1, advice = '') {
    const chatStore = store.state.chat
    return instance({
      url: `message/advice/${chatStore.estimationSessionId}`,
      method: 'POST',
      data: { pageId: chatStore.chatInfo.pageId, estimate, advice },
      isFormdata: true
    })
  },

  /**
   * 评价-新
   * @param estimate 1-非常满意，2-满意，3-一般，4-不满意，5-非常不满意
   * @param advice 评价描述
   */
  estimateNew(data, evaluationDialogid) {
    // const chatStore = store.state.chat
    return instance({
      url: `message/advice/save/${evaluationDialogid}`,
      method: 'POST',
      data
    })
  },
  /**
   * 自动回复
   */
  autoReply(questionId) {
    const chatStore = store.state.chat
    return instance({
      url: `autoReply/replyByQuestion`,
      params: {
        dialogId: chatStore.chatInfo.sessionId,
        pageId: chatStore.chatInfo.pageId,
        questionId
      }
    })
  },
  /**
   *  根据分类id、计划id查询问题分类
   */
  apiSelectQuestionByClassificationIdAndPlanId(questionStr) {
    const chatStore = store.state.chat
    const [questionPlanId, questionPlanClassificationId] = questionStr.split(',')
    return instance({
      url: `question/selectQuestionByClassificationIdAndPlanId`,
      method: 'POST',
      data: {
        dialogId: chatStore.chatInfo.sessionId,
        sc: chatStore.chatInfo.sc,
        questionPlanId,
        questionPlanClassificationId
      }
    })
  },

  /**
   *  查询并发送问题答案
   */
  apiQueryAndSendAnswer(questionStr) {
    const chatStore = store.state.chat
    const [questionId, questionPlanId, questionPlanClassificationId] = questionStr.split(',')
    return instance({
      url: `question/queryAndSendAnswer`,
      method: 'POST',
      data: {
        dialogId: chatStore.chatInfo.sessionId,
        pageId: chatStore.chatInfo.pageId,
        sc: chatStore.chatInfo.sc,
        questionId,
        questionPlanId,
        questionPlanClassificationId
      }
    })
  },
  /**
   * 转留言
   */
  changeToLeaveMessage() {
    return instance({
      url: `changeToLeaveMessage/${store.state.chat.chatInfo.sessionId}`,
      method: 'POST'
    })
  },
  /**
   * 上传多媒体文件
   */
  uploadMedia(formData) {
    return instance({
      url: `customuploadimg`,
      method: 'POST',
      data: formData
    })
  },

  /**
   * 上传多媒体文件-新
   */
  imgUpload(data) {
    return instance({
      header: { 'Content-Type': 'multipart/form-data' },
      url: '/im-file/upload/file',
      method: 'POST',
      data
    })
  },

  /**
   * 上传多媒体文件-新
   */
  fileUpload(data) {
    return instance({
      header: { 'Content-Type': 'multipart/form-data' },
      url: '/im-file/upload/fileForDirect',
      method: 'POST',
      data
    })
  },

  /**
   * 查询 CA 客服信息
   */
  getCAInfo() {
    return instance({
      url: `getCakefu`,
      params: {
        uid: store.state.chat.chatInfo.userId,
        appKey: store.state.chat.chatInfo.appKey
      }
    })
  },
  // 获取订单列表
  apiGetOrderList(data) {
    const { userId, sc } = store.state.chat.chatInfo
    return instance({
      url: `app/order/getOrderList`,
      method: 'POST',
      data: { ...data, sc, uid: userId }
    })
  },
  // 订单详情接口
  apiGetOrderDetail(data) {
    return instance({
      url: `app/order/getOrderDetail`,
      method: 'POST',
      data
    })
  },
  // 你可能想咨询的订单接口
  apiGetOrderMainInfo(data) {
    return instance({
      url: `app/order/getOrderMainInfo`,
      method: 'POST',
      data
    })
  },
  // 发送订单
  apiSendOrder({ orderCode: orderNo, orderTime }) {
    const { pageId, sessionId, sc } = store.state.chat.chatInfo
    return instance({
      url: `/message/sendOrder`,
      method: 'POST',
      data: { clientCode: sc, orderTime, orderNo, pageId, dialogid: sessionId }
    })
  },
  // 获取会话列表
  apiQueryUserDialogList(data) {
    return instance({
      url: `queryUserDialogList`,
      method: 'POST',
      data
    })
  },
  // 添加用户会话排除
  apiExcludeAdd(data) {
    return instance({
      url: `dialoginfo/exclude/add`,
      method: 'POST',
      data
    })
  },
  // 中间页获取跳转地址以及参数信息
  getIMPackUrlForExternalObject(params) {
    return instance({
      url: `messageCenter/getIMPackUrlForExternalObject`,
      method: 'get',
      params
    })
  },
  // 消息撤回
  apiMsgRecall(params) {
    return instance({
      url: 'message/msgRecall',
      method: 'GET',
      params
    })
  },
  // 查询店铺信息
  queryStoreInfoForServiceCenter(params) {
    console.log(params, 'params')
    return instance({
      url: 'app/sale/queryStoreInfoForServiceCenter',
      method: 'GET',
      params
    })
  },
  // 客户上报问答解决/未解决
  apiReportQuestionStatus(data) {
    return instance({
      url: `question/reportQuestionStatus`,
      method: 'POST',
      data
    })
  },
  // 点击自助查询按钮
  apiClickDialogTab(data) {
    return instance({
      url: `clickDialogTab`,
      method: 'POST',
      data
    })
  },
  // 点击下载发票，调查询发票接口
  apiCheckInvoiceStatus(data) {
    return instance({
      url: `checkInvoiceStatus`,
      method: 'POST',
      data
    })
  },
  // 表单-信息收集
  apiSaveWorkorderByInformationCollect(data) {
    return instance({
      url: `message/saveWorkorderByInformationCollect`,
      method: 'POST',
      data
    })
  },
  // 你可能想咨询的商品接口
  apiItemStoreInfo() {
    const { companyId, itemStoreId } = store.state.chat.chatInfo
    return instance({
      url: `item/getItemStoreInfo`,
      method: 'POST',
      data: {
        companyId,
        itemStoreId
      }
    })
  },
  // 发送商品卡片消息
  apiSendItemCard() {
    const { companyId, itemStoreId, sessionId, pageId } = store.state.chat.chatInfo
    return instance({
      url: `message/sendItemCard`,
      method: 'POST',
      data: {
        companyId,
        itemStoreId,
        dialogId: sessionId,
        pageId
      }
    })
  },
  // 客户端-立即转入
  apiImmediatelyTransfer() {
    const { sessionId, userId, sc } = store.state.chat.chatInfo
    return instance({
      url: `message/immediatelyTransfer`,
      method: 'POST',
      data: {
        dialogId: sessionId,
        sc,
        uid: userId
      }
    })
  },
  // 客户端-获取首营资料
  getFirstBusinessMaterials() {
    const { companyId, sessionId, orderNo, pageId, portalType, storeId } = store.state.chat.chatInfo
    return instance({
      url: `/message/getFirstBusinessMaterials`,
      method: 'POST',
      data: {
        companyId,
        dialogId: sessionId,
        orderCode: orderNo,
        pageId,
        portalType,
        storeId
      }
    })
  },
  // 根据客户id或名称查询会员中心基本信息List
  apiCompanyInfoListByCompanyIdOrName(data) {
    return instance({
      url: `app/user/getCompanyInfoListByCompanyIdOrName`,
      method: 'POST',
      data
    })
  },
  // 停止ai消息发送
  apiStopChatbot(data) {
    return instance({
      url: `/message/stopChatbot`,
      method: 'POST',
      data
    })
  },
  // 选择灯塔用户
  apiSendCustomer({ companyId, companyName, companyAddress }) {
    const { sessionId } = store.state.chat.chatInfo
    return instance({
      url: `message/clickChooseDtCustomer`,
      method: 'POST',
      data: { companyId, companyName, companyAddress, dialogId: sessionId }
    })
  },
  // 思考中接口
  apiPreSendChatbot(data) {
    return instance({
      url: `/message/preSendChatbot`,
      method: 'POST',
      data
    })
  },
  // 会话评价新增/修改
  apiAdviceAiSave(data) {
    return instance({
      url: `/message/advice/ai/save`,
      method: 'POST',
      data
    })
  },
  // 点击评价客服，评价客服按钮一直展示，会话提交/修改时校验五分钟三次规则
  apiSendAiEvaluateMessage() {
    const chatStore = store.state.chat
    return instance({
      url: `/message/advice/ai/sendAiEvaluateMessage`,
      method: 'POST',
      data: {
        dialogId: chatStore.chatInfo.sessionId
      }
    })
  }
}
export default api
